<template>
  <div class="moments-wrapbox">
    <div class="moments-top">
      <div
        :class="{
          'moments-top-text': true,
          bold: WEBINAR_PES['ai_creation'] != 1
        }"
      >
        {{ WEBINAR_PES['ai_creation'] != 1 ? $t('lang.k_165001') : $t('lang.k_165002') }}
      </div>
      <!-- <vh-button
        v-if="WEBINAR_PES['ai_creation'] != 1"
        class="moments-top-btn"
        @click="contactCustormer"
      >
        在线客服
      </vh-button> -->
      <vh-button
        v-if="WEBINAR_PES['ai_creation'] == 1"
        class="moments-top-btn active"
        @click="goPage"
      >
        {{ $t('lang.k_165003') }}
      </vh-button>
    </div>
    <div class="moments-middle">
      <div class="moments-middle-tip">{{ $t('lang.k_165004') }}</div>
      <div class="moments-middle-message">
        <div class="moments-middle-message-direction">
          <div class="moments-middle-message-direction-item">
            <vh-icon
              class="moments-middle-message-direction-item-icon vh-iconfont vh-a-line-livemanagement"
            ></vh-icon>
            <div class="moments-middle-message-direction-item-text">{{ $t('lang.k_165005') }}</div>
          </div>
          <img
            class="moments-middle-message-direction-icon"
            src="../../../../../common/images/custom-tab/moment-arrow.png"
            alt=""
          />
          <div class="moments-middle-message-direction-item">
            <vh-icon
              class="moments-middle-message-direction-item-icon vh-iconfont vh-line-film"
            ></vh-icon>
            <div class="moments-middle-message-direction-item-text">{{ $t('lang.k_165006') }}</div>
          </div>
        </div>
        <div class="moments-middle-message-list">
          <div class="moments-middle-message-list-item">
            <div class="moments-middle-message-list-item-title">{{ $t('lang.k_165007') }}</div>
            <div class="moments-middle-message-list-item-text">
              {{ $t('lang.k_165008') }}
              <br />
              {{ $t('lang.k_165009') }}
            </div>
          </div>
          <div class="moments-middle-message-list-item">
            <div class="moments-middle-message-list-item-title">{{ $t('lang.k_165010') }}</div>
            <div class="moments-middle-message-list-item-text">{{ $t('lang.k_165011') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="moments-bottom">
      <div class="moments-bottom-item">
        <h1>{{ $t('lang.k_165012') }}</h1>
        <p>{{ $t('lang.k_165013') }}</p>
        <img
          class="moments-bottom-console-img"
          src="../../../../../common/images/custom-tab/moments-console.png"
        />
      </div>
      <div class="moments-bottom-item">
        <h1>{{ $t('lang.k_165014') }}</h1>
        <p>{{ $t('lang.k_165015') }}</p>
        <img
          class="moments-bottom-wap-img"
          src="../../../../../common/images/custom-tab/moments-wap.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { sessionOrLocal } from '@/utils/utils';
  export default {
    data() {
      return {
        WEBINAR_PES: {}
      };
    },
    created() {
      const permissions = sessionOrLocal.get('WEBINAR_PES', 'localStorage');
      this.WEBINAR_PES = JSON.parse(permissions);
    },
    methods: {
      // 马上创作
      goPage() {
        const liveDetailInfo = JSON.parse(sessionOrLocal.get('liveDetailInfo'));
        window.open(`${window.location.origin}/v3/live/playback/${liveDetailInfo.id}`, '_blank');
      },

      // 联系客服
      contactCustormer() {
        window.open(`https://vhall.s4.udesk.cn/im_client/?web_plugin_id=15038`, '_blank');
      }
    }
  };
</script>

<style lang="less" scoped>
  .moments-wrapbox {
    padding: 1px 0;
    box-sizing: border-box;

    .moments-top {
      display: flex;
      flex-direction: column;
      align-items: center;
      &-text {
        width: 100%;
        font-size: 14px;
        font-weight: 400;
        color: #262626;
        line-height: 22px;
        &.bold {
          font-weight: 600;
        }
      }
      &-btn {
        width: 104px;
        height: 36px;
        padding: 0;
        border: 1px solid #fb2626;
        font-size: 14px;
        color: #fb2626;
        border-radius: 18px;
        margin-top: 24px;

        &.active {
          background: #fb2626;
          border: none;
          color: #ffffff;
        }
      }
    }

    .moments-middle {
      margin-top: 24px;

      &-tip {
        font-size: 14px;
        color: #262626;
        line-height: 20px;
      }

      &-message {
        margin-top: 12px;
        background: #faf7f6;
        height: 216px;

        &-direction {
          padding: 12px 8px;
          display: flex;
          justify-content: center;
          align-items: center;

          &-icon {
            width: 20px;
            height: 20px;
            display: block;
            margin: 0 32px;
          }

          &-item {
            height: 54px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 16px 32px;
            border-radius: 27px;
            background: #ffffff;

            &-icon {
              margin-right: 16px;
              color: #fb2626;
              font-size: 20px;
            }

            &-text {
              font-size: 16px;
              font-weight: 500;
              color: #262626;
            }
          }
        }

        &-list {
          display: flex;
          flex-direction: column;
          align-items: center;

          &-item {
            width: 196px;
            &:last-child {
              margin-top: 8px;
            }
            &-title {
              line-height: 22px;
              font-size: 14px;
              font-weight: 600;
              color: #262626;
            }
            &-text {
              margin-top: 4px;
              line-height: 22px;
              font-size: 14px;
              font-weight: 400;
              color: #262626;
            }
          }
        }
      }
    }

    .moments-bottom {
      height: 311px;
      background: #ebefff;
      margin-top: 12px;
      position: relative;
      padding: 12px 20px 10px 4px;
      display: flex;
      justify-content: center;

      &-item {
        min-width: 172px;
        margin: 0 4px;
        h1 {
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          font-weight: 600;
          color: #262626;
        }
        p {
          margin-top: 2px;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          font-weight: 500;
          color: #595959;
        }
      }

      &-console-img {
        width: 210px;
        margin-top: 12px;
      }
      &-wap-img {
        width: 110px;
        display: block;
        margin: 0 auto;
        margin-top: 12px;
      }
    }
  }
</style>
